import { Text, Stack } from 'braid-design-system';
import { observer } from 'mobx-react';
import type { IEmail } from '../../../stores/JobApplicationStore/Email';
import { parseAndSplitHtmlText } from 'src/utils/parseAndSplitHtmlText';
import HotjarMask from '../../common/HotjarMask';
import SimpleFormat from '../../common/SimpleFormat';

interface Props {
  email: IEmail;
}

const EmailItemContent = ({ email }: Props) => {
  const content = parseAndSplitHtmlText(email.message).map((lines, index) => (
    <Text key={index}>
      <HotjarMask>
        <SimpleFormat text={lines} />
      </HotjarMask>
    </Text>
  ));
  return (
    <Stack space="medium">
      <Text weight="strong">
        <HotjarMask>{email.subject}</HotjarMask>
      </Text>
      <div data-testid="email-content">
        <Stack space="small">{content}</Stack>
      </div>
    </Stack>
  );
};

export default observer(EmailItemContent);
